import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import {
    Rocket,
    Users,
    BookOpen,
    Calendar,
    MapPin,
    ArrowRight,
    ExternalLink,
    Image as ImageIcon,
    Play,
    Quote,
    Lightbulb,
    Briefcase,
    Globe,
    Leaf,
    Camera,
    Code,
    Heart,
    GraduationCap,
} from "lucide-react"
import { Button } from "../../components/ui/button"
import { Helmet } from "react-helmet-async"
import FeaturedPosts from "../../components/Blog/FeaturedPosts"
import { useDispatch, useSelector } from "react-redux"
import { loadPublicEvents } from "../../store/slices/publicSlice"
import { fetchPublicPosts } from "../../api/publicApi"
import { getTypeLabel, getStatusLabel } from "../../utils/announcementEventUtils"
import venusteImg from "../../assets/IDB/venuste.jpeg"
import idb1 from "../../assets/IDB/IDBPHOTO (1).jpg"
import idb2 from "../../assets/IDB/IDBPHOTO (2).jpg"
import idb3 from "../../assets/IDB/IDBPHOTO (3).jpg"
import idb4 from "../../assets/IDB/IDBPHOTO (4).jpg"
import idb5 from "../../assets/IDB/IDBPHOTO (5).jpg"
import idb6 from "../../assets/IDB/IDBPHOTO (6).jpg"
import idb7 from "../../assets/IDB/IDBPHOTO (7).jpg"
import heroImage from "../../assets/TopHeroImages/2.png"

export default function IdeaxBox() {
    const dispatch = useDispatch()
    const { events } = useSelector((s) => s.public)
    const [featuredPosts, setFeaturedPosts] = useState([])

    useEffect(() => {
        dispatch(loadPublicEvents({ status: "ongoing" }))
    }, [dispatch])

    useEffect(() => {
        fetchPublicPosts({ category: "blogOfSpaceOfStudents", limit: 3 })
            .then((data) => {
                setFeaturedPosts(data.posts || [])
            })
            .catch(() => {})
    }, [])

    const clubs = [
        {
            name: "Club DIH (Droit International Humanitaire)",
            detail: "Affilié à la Croix-Rouge Burundi (branche Ngozi)",
            desc: "Sensibilisation au droit humanitaire, formations en premiers secours (environ 30 étudiants formés), participation à des actions humanitaires.",
            icon: Heart,
        },
        {
            name: "Club Umuco n'Akaranga",
            detail: "",
            desc: "Appui logistique aux événements (mariages, cérémonies), génération de revenus et développement personnel des membres.",
            icon: Users,
        },
        {
            name: "Agriculture Food for Life",
            detail: "",
            desc: "Culture de patate douce à chair jaune et transformation en produits dérivés (pain, beignets), promotion de l'innovation agricole.",
            icon: Leaf,
        },
        {
            name: "Club UMUCO (United Movement for Uplifting and Championing Opportunities)",
            detail: "",
            desc: "Autonomisation des jeunes filles, leadership féminin et développement personnel.",
            icon: GraduationCap,
        },
        {
            name: "ECYA (Environment Conscious Youth Association)",
            detail: "",
            desc: "Protection de l'environnement, nettoyage de la ville de Ngozi, sensibilisation au développement durable.",
            icon: Globe,
        },
        {
            name: "Creasoft Club",
            detail: "",
            desc: "Photographie, montage vidéo, production de contenus numériques et couverture médiatique des événements universitaires.",
            icon: Camera,
        },
        {
            name: "Spider Web",
            detail: "",
            desc: "Développement de sites web et plateformes numériques pour clubs et organisations locales.",
            icon: Code,
        },
    ]

    const projetsRealises = [
        "L'organisation de formations en premiers secours avec la Croix-Rouge.",
        "La production et transformation de produits agricoles innovants.",
        "La création de contenus numériques et médiatiques.",
        "Le développement de sites web et plateformes digitales.",
        "L'organisation d'un programme hebdomadaire de débat.",
        "Une formation de base en espagnol pour 12 étudiants.",
        "Des ateliers professionnels sur le CV, les entretiens et l'usage responsable de l'IA.",
        "Des séances d'information sur les opportunités internationales (Campus France).",
    ]

    const activitesProposees = [
        "Réunions hebdomadaires des clubs.",
        "Programme de débat et simulations d'éloquence.",
        "Ateliers de formation professionnelle.",
        "Formations numériques et multimédia.",
        "Activités de recherche et travaux académiques.",
        "Conférences et rencontres inspirantes.",
        "Apprentissage collaboratif et mentorat.",
        "Sensibilisation environnementale et humanitaire.",
    ]

    const outilsRessources = [
        "Ordinateurs connectés à Internet",
        "Tablettes numériques",
        "Caméras et équipements audiovisuels",
        "Ressources pédagogiques numériques",
        "Ouvrages sur les soft skills et le développement personnel",
        "Espaces collaboratifs de réunion",
        "Accompagnement par six facilitateurs volontaires",
    ]

    const stats = [
        { label: "Ouverture", value: "16 nov. 2022", icon: Calendar },
        { label: "Clubs", value: "7", icon: Users },
        { label: "Facilitateurs", value: "6", icon: Briefcase },
    ]

    const gallery = [
        { title: "Ideas Box", desc: "Espace du centre", img: idb1 },
        { title: "Programme de débat", desc: "Chaque vendredi", img: idb2 },
        { title: "La bibliothèque", desc: "Apprentissage et insertion professionnelle", img: idb3 },
        { title: "Exploration personnelle", desc: "Des étudiants", img: idb4 },
        { title: "Travaux pratiques", desc: "Étudiants aux TP", img: idb5 },
        { title: "Travail de groupe", desc: "Collaboration étudiante", img: idb6 },
        { title: "Espace de travail", desc: "Ressources numériques", img: idb7 },
    ]

    const navSections = [
        { id: "presentation", label: "Présentation" },
        { id: "clubs", label: "Les clubs" },
        { id: "projets", label: "Projets réalisés" },
        { id: "activites", label: "Activités" },
        { id: "ressources", label: "Ressources" },
        { id: "responsable", label: "Responsable" },
    ]

    return (
        <div className="min-h-screen bg-background font-sans text-foreground antialiased">
            <Helmet>
                <title>Ideas Box - Université de Ngozi</title>
                <meta
                    name="description"
                    content="Le centre Ideas Box de l'Université de Ngozi : espace d'innovation, d'apprentissage et de cohésion sociale. Vision, mission, clubs, projets et ressources."
                />
            </Helmet>

            {/* Hero — Standard (ref: Campus, MissionVision) */}
            <header className="relative min-h-[60vh] flex items-center bg-primary overflow-hidden">
                <div className="absolute inset-0 z-0">
                    {heroImage && <img src={heroImage} alt="Ideas Box - Université de Ngozi" className="w-full h-full object-cover opacity-40 mix-blend-luminosity scale-105" />}
                    <div className="absolute inset-0 bg-gradient-to-r from-primary via-primary/80 to-transparent" />
                </div>
                <div className="container relative z-10 py-20">
                    <div className="max-w-3xl">
                        <div className="inline-flex items-center gap-4 mb-8 translate-y-4 animate-in fade-in duration-700 fill-mode-forwards">
                            <span className="text-[10px] uppercase tracking-[0.3em] text-accent font-black">Ideas Box</span>
                            <div className="h-px w-12 bg-accent/50" />
                            <span className="text-[10px] text-primary-foreground/60 uppercase tracking-widest font-bold">Université de Ngozi</span>
                        </div>
                        <h1 className="heading-1 mb-8 leading-[0.95] font-serif tracking-tight text-white translate-y-4 animate-in fade-in duration-1000 fill-mode-forwards delay-200">
                            <span className="block italic font-light text-accent/90">Innovation, apprentissage</span>
                            <span className="block text-white mt-2">et cohésion sociale</span>
                        </h1>
                        <div className="border-l-4 border-accent pl-6 mb-10 max-w-2xl translate-y-4 animate-in fade-in duration-1000 fill-mode-forwards delay-500">
                            <p className="text-sm md:text-base font-light leading-relaxed text-primary-foreground/90">
                                Un espace dédié aux étudiants et à la communauté environnante : former une jeunesse consciente, autonome et capable d'innover.
                            </p>
                        </div>
                        <div className="flex flex-wrap gap-6 items-center translate-y-4 animate-in fade-in duration-1000 fill-mode-forwards delay-700">
                            <a href="#presentation">
                                <Button className="bg-accent text-accent-foreground px-10 py-7 text-sm font-black transition-all duration-300 border-b-4 border-black/20 rounded-xl">
                                    Découvrir
                                    <ArrowRight className="w-5 h-5 ml-3" />
                                </Button>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="absolute bottom-10 left-1/2 -translate-x-1/2 animate-bounce opacity-20">
                    <div className="w-px h-12 bg-white" />
                </div>
            </header>

            {/* Stats bar — match Campus / Valeurs */}
            <div className="border-y border-border bg-secondary/5">
                <div className="container py-4 flex flex-wrap items-center gap-10 lg:gap-16">
                    {stats.map((stat, i) => (
                        <div key={i} className="flex items-center gap-2 group">
                            <span className="text-lg font-black text-primary group-hover:text-accent transition-colors">{stat.value}</span>
                            <span className="text-[10px] text-muted-foreground uppercase font-black tracking-[0.2em]">{stat.label}</span>
                            {i < stats.length - 1 && <span className="hidden lg:block h-4 w-px bg-border ml-4" />}
                        </div>
                    ))}
                </div>
            </div>

            <article className="container py-12 lg:py-16 max-w-5xl mx-auto">
                <main className="space-y-16">
                    {/* Breadcrumb */}
                    <div className="flex items-center gap-2 text-[11px] text-muted-foreground -mt-4 mb-2">
                        <Link to="/" className="hover:text-primary transition-colors">Accueil</Link>
                        <span>/</span>
                        <Link to="/etudiants/blog" className="hover:text-primary transition-colors">Étudiants</Link>
                        <span>/</span>
                        <span className="text-foreground font-medium">Ideas Box</span>
                    </div>

                    {/* Compact summary — horizontal anchor links, no left gap */}
                    <nav className="flex flex-wrap items-center gap-2 py-3 border-y border-border/80">
                        <span className="text-[10px] uppercase tracking-widest font-black text-muted-foreground mr-1">Sommaire</span>
                        {navSections.map((item, i) => (
                            <a
                                key={item.id}
                                href={`#${item.id}`}
                                className="px-2.5 py-1 rounded-md text-[11px] font-bold text-muted-foreground hover:text-primary hover:bg-primary/5 transition-colors"
                            >
                                {item.label}
                            </a>
                        ))}
                    </nav>

                    {/* Présentation */}
                    <section id="presentation" className="scroll-mt-24">
                        <h2 className="text-xl lg:text-2xl font-serif font-black italic text-foreground mb-5 flex items-center gap-2">
                            <div className="w-8 h-0.5 bg-accent rounded-full" />
                            Présentation de l'espace (Vision, Mission et Histoire)
                        </h2>
                        <div className="grid lg:grid-cols-2 gap-8 items-start">
                            <div className="relative group order-2 lg:order-1">
                                <div className="aspect-[4/3] rounded-xl overflow-hidden border border-border relative shadow-lg">
                                    <img src={idb6} alt="Centre Ideas Box" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-end p-5">
                                        <div className="translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                                            <p className="text-white text-sm font-bold mb-1">Centre Ideas Box</p>
                                            <p className="text-white/80 text-xs">Espace d'innovation et d'apprentissage</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="space-y-3 order-1 lg:order-2 text-muted-foreground leading-relaxed text-sm">
                                <p>
                                        Le centre Ideas Box de l'Université de Ngozi est un espace d'innovation, d'apprentissage et de cohésion sociale dédié aux étudiants et à la communauté environnante. Il a été officiellement ouvert le <strong className="text-foreground">16 novembre 2022</strong> dans le cadre du projet « Favoriser l'accès à la mobilité et à l'employabilité des jeunes au Burundi », financé par l'Union Européenne à travers Bibliothèques Sans Frontières, en partenariat avec l'Université de Ngozi, pour une durée de deux ans.
                                    </p>
                                    <p>
                                        À l'origine, le centre fonctionnait grâce à des coachs-formateurs chargés d'accompagner les étudiants dans le développement de leurs compétences académiques, numériques et professionnelles. À la fin du projet, l'Université de Ngozi a pris en main la continuité du fonctionnement du centre, assurant ainsi sa pérennité et son ancrage institutionnel.
                                    </p>
                                    <p>
                                        Aujourd'hui, le centre Ideas Box est bien plus qu'un espace de ressources : il constitue un <strong className="text-foreground">véritable incubateur de talents et d'initiatives étudiantes</strong>. Sa vision est de former une jeunesse consciente, autonome et capable d'innover. Sa mission est d'offrir un accès inclusif aux outils numériques, d'encourager l'entrepreneuriat, de renforcer les compétences transversales et de promouvoir l'engagement communautaire.
                                    </p>
                                    <p>
                                        Avec un nombre remarquable de fréquentations enregistrées, le centre joue un rôle majeur dans la dynamique académique et sociale de l'université.
                                    </p>
                                </div>
                            </div>
                        </section>

                    {/* Les clubs */}
                    <section id="clubs" className="scroll-mt-24">
                        <h2 className="text-xl lg:text-2xl font-serif font-black italic text-foreground mb-3 flex items-center gap-2">
                            <div className="w-8 h-0.5 bg-accent rounded-full" />
                            Les clubs de l'espace
                        </h2>
                        <p className="text-sm text-muted-foreground mb-5 max-w-2xl">Le centre accueille plusieurs clubs et mouvements étudiants :</p>
                        <div className="grid md:grid-cols-2 gap-4">
                            {clubs.map((club, idx) => {
                                const Icon = club.icon
                                return (
                                    <div key={idx} className="group p-5 bg-secondary/5 rounded-xl border border-border hover:border-accent/30 transition-all duration-300">
                                        <Icon className="w-9 h-9 text-primary mb-4 opacity-30 group-hover:opacity-100 group-hover:text-accent transition-all" />
                                        <h3 className="text-sm font-black uppercase tracking-tight text-foreground mb-0.5">{club.name}</h3>
                                        {club.detail && <p className="text-[10px] text-muted-foreground mb-2">{club.detail}</p>}
                                        <p className="text-xs text-muted-foreground leading-relaxed">{club.desc}</p>
                                    </div>
                                )
                            })}
                        </div>
                    </section>

                    {/* Projets réalisés */}
                    <section id="projets" className="scroll-mt-24">
                        <h2 className="text-xl lg:text-2xl font-serif font-black italic text-foreground mb-3 flex items-center gap-2">
                            <div className="w-8 h-0.5 bg-accent rounded-full" />
                            Les projets réalisés dans l'espace
                        </h2>
                        <p className="text-sm text-muted-foreground mb-4">Depuis son ouverture, le centre Ideas Box a permis :</p>
                        <ul className="space-y-2 mb-6 text-sm">
                            {projetsRealises.map((item, i) => (
                                <li key={i} className="flex items-center gap-2 text-muted-foreground">
                                    <div className="w-1.5 h-1.5 bg-accent rounded-full flex-shrink-0" />
                                    <span>{item}</span>
                                </li>
                            ))}
                        </ul>
                        <div className="bg-primary/5 p-6 border border-primary/10 rounded-xl relative overflow-hidden">
                            <div className="absolute top-0 right-0 w-24 h-24 bg-accent/5 rounded-full -mr-12 -mt-12" />
                            <div className="relative space-y-3 text-sm text-foreground/90 leading-relaxed">
                                <p>
                                    Le programme de débat, organisé chaque vendredi, a constitué l'un des projets phares de 2025. Sous le coaching du coordinateur du centre, les étudiants ont participé aux compétitions URUMURI HUB organisées par Resolution Connect. Après une phase éliminatoire, cinq étudiants ont remporté la demi-finale le 15 octobre 2025, accédant ainsi à la finale. Leur performance remarquable leur a permis d'obtenir le prix final de la compétition d'éloquence.
                                </p>
                                <p>
                                    Un étudiant en informatique a également remporté la finale des Umwuga Awards le 31 octobre 2025, sous l'encadrement du centre.
                                </p>
                            </div>
                        </div>
                    </section>

                    {/* Activités */}
                    <section id="activites" className="scroll-mt-24">
                        <h2 className="text-xl lg:text-2xl font-serif font-black italic text-foreground mb-5 flex items-center gap-2">
                            <div className="w-8 h-0.5 bg-accent rounded-full" />
                            Les activités proposées par l'espace
                        </h2>
                        <ul className="grid sm:grid-cols-2 gap-2 text-sm text-muted-foreground">
                            {activitesProposees.map((item, i) => (
                                <li key={i} className="flex items-center gap-2">
                                    <div className="w-1.5 h-1.5 bg-accent rounded-full flex-shrink-0" />
                                    <span>{item}</span>
                                </li>
                            ))}
                        </ul>
                    </section>

                    {/* Témoignages */}
                    <section id="temoignages" className="scroll-mt-24">
                        <h2 className="text-xl lg:text-2xl font-serif font-black italic text-foreground mb-5 flex items-center gap-2">
                            <div className="w-8 h-0.5 bg-accent rounded-full" />
                            Témoignages des étudiants
                        </h2>
                        <div className="grid md:grid-cols-2 gap-5">
                            <blockquote className="group p-5 bg-secondary/5 rounded-xl border border-border hover:border-accent/30 transition-all">
                                <Quote className="w-8 h-8 text-primary/30 mb-3 group-hover:text-accent transition-colors" />
                                <p className="italic text-sm text-muted-foreground leading-relaxed mb-4">
                                    « Grâce au programme de débat, j'ai appris à structurer mes idées et à parler avec confiance devant un public. Cette expérience m'a ouvert de nouvelles opportunités. »
                                </p>
                                <footer className="not-italic font-bold uppercase tracking-tight text-foreground text-xs">NININAHAZWE Tatiana</footer>
                            </blockquote>
                            <blockquote className="group p-5 bg-secondary/5 rounded-xl border border-border hover:border-accent/30 transition-all">
                                <Quote className="w-8 h-8 text-primary/30 mb-3 group-hover:text-accent transition-colors" />
                                <p className="italic text-sm text-muted-foreground leading-relaxed mb-4">
                                    « Ideas Box m'a permis d'acquérir des compétences pratiques en informatique et en communication que je n'aurais pas développées uniquement en salle de classe et le centre est devenu un espace où nous pouvons transformer nos idées en projets concrets. »
                                </p>
                                <footer className="not-italic font-bold uppercase tracking-tight text-foreground text-xs">MUGISHA Elvis</footer>
                            </blockquote>
                        </div>
                    </section>

                    {/* Outils et ressources */}
                    <section id="ressources" className="scroll-mt-24">
                        <h2 className="text-xl lg:text-2xl font-serif font-black italic text-foreground mb-5 flex items-center gap-2">
                            <div className="w-8 h-0.5 bg-accent rounded-full" />
                            Outils et ressources disponibles
                        </h2>
                        <ul className="grid sm:grid-cols-2 gap-2 text-sm text-muted-foreground">
                            {outilsRessources.map((item, i) => (
                                <li key={i} className="flex items-center gap-2">
                                    <div className="w-1.5 h-1.5 bg-primary rounded-full flex-shrink-0" />
                                    <span>{item}</span>
                                </li>
                            ))}
                        </ul>
                    </section>

                    {/* Biographie responsable */}
                    <section id="responsable" className="scroll-mt-24">
                        <h2 className="text-xl lg:text-2xl font-serif font-black italic text-foreground mb-5 flex items-center gap-2">
                            <div className="w-8 h-0.5 bg-accent rounded-full" />
                            Biographie du responsable
                        </h2>
                        <div className="flex flex-col sm:flex-row gap-5 p-5 sm:p-6 rounded-xl border border-border bg-secondary/5 hover:border-primary/20 transition-colors">
                            <div className="w-28 h-28 sm:w-32 sm:h-32 rounded-xl overflow-hidden border border-border flex-shrink-0 bg-primary/5 mt-3">
                                <img src={venusteImg} alt="Vénuste NDAYIYUNGEKO — Coach-formateur et coordinateur du centre Ideas Box" className="w-full h-full object-cover" />
                            </div>
                            <div className="space-y-3 flex-1 text-sm">
                                <p className="text-[10px] font-black text-muted-foreground uppercase tracking-[0.2em]">Responsable</p>
                                <h3 className="text-lg font-serif font-black italic text-foreground">Vénuste NDAYIYUNGEKO</h3>
                                <p className="text-muted-foreground leading-relaxed">
                                    Coach-formateur en développement des compétences et coordinateur du centre Ideas Box de l'Université de Ngozi. Engagé dans la promotion de l'employabilité des jeunes et le renforcement des capacités communautaires, il accompagne des initiatives éducatives, humanitaires et entrepreneuriales depuis plusieurs années.
                                </p>
                                <p className="text-muted-foreground leading-relaxed">
                                    Depuis la mise en place du centre Ideas Box en 2022, il contribue activement à son développement et à la coordination des programmes destinés aux étudiants. En 2025, il a piloté et coaché le programme de débat, préparant les étudiants aux compétitions nationales d'éloquence, où ils ont remporté le prix final après un parcours remarquable.
                                </p>
                                <p className="text-muted-foreground leading-relaxed">
                                    Titulaire d'un bachelier en sciences de gestion, il possède une solide expérience en coordination de projets, en formation et en accompagnement de jeunes, notamment dans des programmes liés à l'inclusion socio-économique, au leadership et au développement durable. Son engagement vise à construire une jeunesse compétente, confiante et capable d'impacter positivement sa communauté.
                                </p>
                            </div>
                        </div>
                    </section>

                    {/* Gallery */}
                    <section>
                        <div className="flex items-center justify-between mb-4">
                            <h2 className="text-xl lg:text-2xl font-serif font-black italic text-foreground flex items-center gap-2">
                                <div className="w-8 h-0.5 bg-accent rounded-full" />
                                Nos espaces
                            </h2>
                            <Link to="/galerie" className="text-[11px] font-bold text-primary hover:text-accent transition-colors flex items-center gap-1 uppercase tracking-widest">
                                Voir la galerie
                                <ExternalLink className="w-3 h-3" />
                            </Link>
                        </div>
                        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-3">
                            {gallery.map((item, idx) => (
                                <div
                                    key={idx}
                                    className="group aspect-[4/3] sm:aspect-square bg-secondary/5 rounded-xl border border-border hover:border-accent/30 transition-all cursor-pointer flex flex-col items-center justify-center p-0 relative overflow-hidden text-center"
                                >
                                    {item.img ? (
                                        <>
                                            <img src={item.img} alt={item.title} className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                                            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-80 group-hover:opacity-100 transition-opacity" />
                                            <div className="relative z-10 p-4 mt-auto w-full flex flex-col items-start text-left">
                                                <p className="text-[11px] font-bold uppercase tracking-tight text-white mb-0.5">{item.title}</p>
                                                {item.desc && <p className="text-[10px] text-white/80 leading-tight">{item.desc}</p>}
                                            </div>
                                        </>
                                    ) : (
                                        <div className="p-3">
                                            <ImageIcon className="w-8 h-8 text-primary/50 group-hover:text-accent mb-1 transition-colors mx-auto" />
                                            <p className="text-[11px] font-bold uppercase tracking-tight text-foreground">{item.title}</p>
                                            {item.desc && <p className="text-[10px] text-muted-foreground mt-0.5 leading-tight">{item.desc}</p>}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </section>

                    {/* Annonces et Événements */}
                    {events.length > 0 && (
                        <section>
                            <h2 className="text-xl lg:text-2xl font-serif font-black italic text-foreground mb-4 flex items-center gap-2">
                                <div className="w-8 h-0.5 bg-accent rounded-full" />
                                Annonces et Événements
                            </h2>
                            <div className="space-y-3">
                                {events.slice(0, 6).map((ev) => (
                                    <div key={ev._id} className="p-4 bg-secondary/5 rounded-xl border border-border hover:border-accent/30 transition-all">
                                        <div className="flex flex-wrap items-center gap-2 mb-1">
                                            <span className="px-2 py-0.5 bg-accent/20 text-accent rounded text-[10px] font-black uppercase tracking-widest">{getTypeLabel(ev.type)}</span>
                                            <span className="px-2 py-0.5 bg-primary/20 text-primary rounded text-[10px] font-bold">{getStatusLabel(ev.effectiveStatus)}</span>
                                        </div>
                                        <h3 className="text-sm font-bold text-foreground mb-1">{ev.title}</h3>
                                        <div className="flex flex-wrap gap-3 text-[11px] text-muted-foreground">
                                            {ev.startDate && (
                                                <span className="flex items-center gap-1">
                                                    <Calendar className="w-3 h-3" />
                                                    {new Date(ev.startDate).toLocaleDateString("fr-FR", { day: "numeric", month: "short", year: "numeric" })}
                                                </span>
                                            )}
                                            {ev.place && (
                                                <span className="flex items-center gap-1">
                                                    <MapPin className="w-3 h-3" />
                                                    {ev.place}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </section>
                    )}

                    {/* Actualités & Blog */}
                    <section aria-labelledby="actualites-blog-heading">
                        <h2 id="actualites-blog-heading" className="text-xl lg:text-2xl font-serif font-black italic text-foreground mb-3 flex items-center gap-2">
                            <div className="w-8 h-0.5 bg-accent rounded-full" />
                            Actualités & Blog
                        </h2>
                        <p className="text-sm text-muted-foreground max-w-2xl mb-5 leading-relaxed">
                            Suivez l'actualité du centre Ideas Box : innovation, entrepreneuriat, événements et conseils pour vos projets.
                        </p>
                            <FeaturedPosts
                                posts={featuredPosts}
                                space="ideax-box"
                                limit={3}
                                showViewAll={true}
                                blogPath="/etudiants/blog/ideax-box"
                                showSectionTitle={false}
                                emptyMessage="Aucun article publié pour le moment. Revenez bientôt."
                            />
                        </section>
                    </main>
            </article>

            {/* Footer CTA — match Campus / MissionVision */}
            <footer className="bg-primary text-white border-t-8 border-accent relative overflow-hidden">
                <div className="absolute top-0 right-0 w-1/3 h-full bg-accent/5 -skew-x-12 origin-top-right pointer-events-none" />
                <div className="container py-16 text-center relative z-10">
                    <div className="max-w-2xl mx-auto space-y-10">
                        <div className="inline-flex items-center gap-6 mb-4">
                            <div className="h-px w-8 bg-accent" />
                            <span className="text-[11px] uppercase tracking-[0.4em] text-accent font-black">Rejoignez Ideas Box</span>
                            <div className="h-px w-8 bg-accent" />
                        </div>
                        <h2 className="text-2xl lg:text-4xl font-serif italic mb-6 leading-tight">
                            Prêt à lancer votre projet ?<br />
                            <span className="text-accent underline decoration-accent/30 decoration-4 underline-offset-4">Transformez vos idées en réalité</span>.
                        </h2>
                        {/* <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                            <Button className="bg-accent text-accent-foreground px-8 py-5 text-xs font-black hover:bg-white hover:text-primary hover:-translate-y-1 transition-all duration-500 rounded-xl transform shadow-xl">
                                Postuler Maintenant
                                <ArrowRight className="w-5 h-5 ml-3" />
                            </Button>
                            <Button variant="ghost" className="text-white border-2 border-white/20 hover:bg-white/5 px-8 py-5 text-xs font-black rounded-xl transition-all">
                                En Savoir Plus
                            </Button>
                        </div> */}
                        <p className="text-white/40 text-[10px] uppercase tracking-[0.2em] font-medium mt-8">
                            © {new Date().getFullYear()} Université de Ngozi · Ideas Box
                        </p>
                    </div>
                </div>
            </footer>
        </div>
    )
}
